import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ContextProvider } from "./contextProvider/ContextProvider";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  // Get the ID parameter from WordPress data or data attribute
  const id = window.wpData?.id || rootElement.dataset.paramId;

  root.render(
    <React.StrictMode>
      <ContextProvider>
        <App wpId={id} />
      </ContextProvider>
    </React.StrictMode>
  );
}

// Keep reportWebVitals if you're using it
reportWebVitals();
